<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAccount } from 'dashboard/composables/useAccount';
import Banner from 'dashboard/components-next/banner/Banner.vue';

const { t } = useI18n();
const router = useRouter();
const { isAdmin } = useAdmin();
const { currentAccount, accountId } = useAccount();

const customAttributes = computed(
  () => currentAccount.value?.custom_attributes || {}
);
const markedForDeletionAt = computed(
  () => customAttributes.value.marked_for_deletion_at
);
const markedForDeletionReason = computed(
  () => customAttributes.value.marked_for_deletion_reason
);

const deletionDate = computed(() => {
  if (!markedForDeletionAt.value) return '';
  const parsed = new Date(markedForDeletionAt.value);
  if (Number.isNaN(parsed.getTime())) return markedForDeletionAt.value;
  return parsed.toLocaleDateString();
});

const shouldShow = computed(
  () => isAdmin.value && Boolean(markedForDeletionAt.value)
);

const bannerMessage = computed(() => {
  const interpolations = { deletionDate: deletionDate.value };
  if (markedForDeletionReason.value === 'inactivity') {
    return t(
      'APP_GLOBAL.ACCOUNT_SCHEDULED_DELETION.MESSAGE_INACTIVITY',
      interpolations
    );
  }
  return t(
    'APP_GLOBAL.ACCOUNT_SCHEDULED_DELETION.MESSAGE_MANUAL',
    interpolations
  );
});

const goToSettings = () => {
  router.push({
    name: 'general_settings_index',
    params: { accountId: accountId.value },
  });
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShow"
    color="ruby"
    class="!rounded-none !justify-center"
    :action-label="t('APP_GLOBAL.ACCOUNT_SCHEDULED_DELETION.ACTION')"
    @action="goToSettings"
  >
    <span class="text-xs">{{ bannerMessage }}</span>
  </Banner>
</template>
